import styled from "@emotion/styled";
export const Input = styled("input")`
    opacity: 0;
    user-select: none;

    // For screen readers, the focus ring treatment is sometimes automatically applied to the input
    // element and we don't control it. In this case, it's nice to have the input take up the same
    // amount of space as the checkbox.
    position: absolute;
    inset: 0;
    margin: 0;
    padding: 0;

    // Bring the input to the front so that it can receive mouse events.
    z-index: 1;

    cursor: pointer;

    // Some cases, we want to have different curser states when the checkbox is disabled. This allowes if when its define the var at the different
    // team levels
    &[aria-disabled="true"] {
        cursor: var(--sds--form--cursor--disabled, not-allowed);
    }

    &:focus {
        outline: none !important;
    }
`;
//# sourceMappingURL=Input.js.map